/**
 * Suporte em modo demo: tipos/motivos/salas, lista de chamados e POST que acrescenta ticket.
 */

function isoHoursAgo(h) {
  const d = new Date();
  d.setHours(d.getHours() - h);
  return d.toISOString();
}

export function getDemoSupportTypes() {
  return [
    { CODIGO: "1", MOTIVO: "Sistema / diário de classe" },
    { CODIGO: "2", MOTIVO: "Infraestrutura física" },
    { CODIGO: "3", MOTIVO: "Outros" }
  ];
}

export function getDemoSupportReasons() {
  return [
    { CODIGO: "1", MOTIVO: "Erro ao lançar notas" },
    { CODIGO: "2", MOTIVO: "Acesso ao sistema" },
    { CODIGO: "3", MOTIVO: "Projetor / equipamentos" },
    { CODIGO: "4", MOTIVO: "Dúvida geral" }
  ];
}

export function getDemoSupportClasses() {
  return [
    { DESCRICAO: "Auditório" },
    { DESCRICAO: "Laboratório de informática" },
    { DESCRICAO: "Sala 101" },
    { DESCRICAO: "Sala 202" }
  ];
}

let nextTicketId = 1000;

/** Estado em memória (novos chamados até recarregar a página). */
let tickets = [
  {
    id: 892,
    statusId: 1,
    createdAt: isoHoursAgo(72),
    description: "Projetor da sala 101 não liga após atualização.",
    SupportReason: {
      name: "Projetor / equipamentos",
      SupportType: { name: "Infraestrutura física" }
    }
  },
  {
    id: 893,
    statusId: 2,
    createdAt: isoHoursAgo(48),
    description: "Dúvida sobre exportação de relatório de frequência.",
    SupportReason: {
      name: "Dúvida geral",
      SupportType: { name: "Sistema / diário de classe" }
    }
  },
  {
    id: 894,
    statusId: 1,
    createdAt: isoHoursAgo(8),
    description: "Não consigo salvar notas na turma 7º A (demo).",
    SupportReason: {
      name: "Erro ao lançar notas",
      SupportType: { name: "Sistema / diário de classe" }
    }
  }
];

export function getDemoSupportsList() {
  return tickets.map(t => ({ ...t }));
}

export function getDemoSupportsCount() {
  return tickets.length;
}

/**
 * @param {object} body — payload de Supports/sendSupportEmail (type, supportReason, location, description, campusId)
 */
export function addDemoSupportTicket(body) {
  const typeName = body.type || "Outros";
  const reasonName = body.supportReason || "Dúvida geral";
  const id = nextTicketId;
  nextTicketId += 1;
  const ticket = {
    id,
    statusId: 1,
    createdAt: new Date().toISOString(),
    description: body.description || "",
    location: body.location || "",
    SupportReason: {
      name: reasonName,
      SupportType: { name: typeName }
    }
  };
  tickets = [ticket, ...tickets];
  return ticket;
}
